<template>
    <va-edit-layout>
        <ShipmentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
